import { uniq } from "lodash";
import { DetailedError } from "./DetailedError";

type ErrorPageMessages = {
  firstMessage: string;
  secondMessage: string;
  thirdMessage: string;
};

type ErrorCode = {
  code: string;
  messages: ErrorPageMessages;
};

const defaultErrorMessage: ErrorPageMessages = {
  firstMessage: "Something unexpected happened.",
  secondMessage:
    "Please refresh the page or contact your customer support for further assistance. We apologize for any inconvenience.",
  thirdMessage:
    "You may be still able to access this page from our classic experience.",
};

const errorCodes: ErrorCode[] = [
  {
    code: "DeletedOrderError",
    messages: {
      firstMessage: "This order has been deleted.",
      secondMessage:
        "Please contact JOOR Support if you need further assistance.",
      thirdMessage: "",
    },
  },
  {
    code: "ImproperPermissionsError",
    messages: {
      firstMessage: "You do not have permission to view this order.",
      secondMessage:
        "Please contact JOOR Support if you need further assistance.",
      thirdMessage: "",
    },
  },
];

export const mapError = (error: DetailedError | { message: string }): any =>
  error && error instanceof DetailedError
    ? {
        message: error.message ? error.message : "",
        code: error.code ? error.code : "",
        errors: uniq(error.errors.flatMap(mapError)),
      }
    : error?.message
    ? error.message
    : error ?? "";

export const errorMapToMessages = ({ error }: { error: Error }) => {
  const toSearch: string = mapError(error).errors.join(" ");
  return error instanceof DetailedError
    ? errorCodes.find((errorCode) => toSearch.includes(errorCode.code))
        ?.messages ?? defaultErrorMessage
    : defaultErrorMessage;
};
